export default __webpack_public_path__ + "static/media/logo.6796e730.svg";